<template>
  <nuttrema-layout-form-standard :edit="edit" :saveError="ProgramDetails.saveError">
    <template slot="center">
      <el-form
        :model="options"
        :rules="rules"
        :label-position="labelPosition"
        :ref="formRef"
        label-width="20em">

        <section >
          <div class="section_items">
            <el-form-item prop="confirmDelete" :label="$t('label.delete')">
              <el-checkbox v-model="options.confirmDelete" :disabled="!edit">{{ $t('label.confirm_action') }}</el-checkbox>
              <p class="el-form-item__help">{{ $t('label.confirm_delete_help') }}</p>
            </el-form-item>

             <el-form-item>
              <el-checkbox v-model="formData.keep_template" :disabled="!edit">{{ $t('label.keep_template') }}</el-checkbox>
              <p class="el-form-item__help">{{ $t('label.keep_template_help') }}</p>
            </el-form-item>
          </div>
        </section>

      </el-form>
    </template>

    <template slot="footer">
      <nav class="footer-row">
        <permissions-control-wrapper
           action="label.delete"
           tooltip-placement="right"
          :required-general="$PERMISSIONS_GENERAL.DELETE"
          :permissions="_get(ProgramDetails, 'meta.permissions')">
          <el-button
             slot="allowed"
             type="danger"
             size="small"
            :loading="ProgramDetails.saving"
            :disabled="!options.confirmDelete"
            @click="handleDelete">
            {{ $t('label.delete') }}
          </el-button>
          <el-button
             slot="not-allowed"
             type="info"
             size="small"
             class="is-icon"
             icon="far fa-lock-alt"
            :disabled="!edit">
            {{ $t('label.delete') }}
          </el-button>
        </permissions-control-wrapper>

        <el-button
           type="text"
           size="small"
          @click="cancelChanges">
          {{ $t('label.cancel') }}
        </el-button>
      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import { get } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import StuffToEatInfoSmallCard from 'components/ui/card/stuff-to-eat-info-small-card';
import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';
import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';

export default {
  name: 'form-program-delete',
  mixins: [FormStandardBehavior],
  props: {
    id: {
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    ProgramDetails: {
      type: Object,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    NuttremaGroupAndSort,
    StuffToEatInfoSmallCard,
    NuttremaLayoutFormStandard,
    PopoverQuestionAlert,
  },
  data() {
    return {
      options: {
        confirmDelete: false,
      },
      formData: {
        keep_template: true,
      },
      rules: {
        confirmDelete: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.confirm_delete', true),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    getFormData() {
      return this.formData;
    },
    handleDelete() {
      const data = this.getFormData();
      this.$emit('delete', this.toJSON(data));
    },
  },
  computed: {
    programType() {
      return get(this.ProgramDetails, 'data.assigned') ? 'assigned' : 'template';
    },
  },
  created() {
    this.stateData = this.ProgramDetails;
    this.formRef = 'form-program-delete';
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/settings/delete/form-program-delete.vue